module.exports = __webpack_public_path__ + "img/icon_btn_internet_w.1594b788.svg";